import React, { useState, useEffect, useRef } from 'react';

// import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import Tab from 'react-bootstrap/Tab';
// import Tabs from 'react-bootstrap/Tabs';
import ApexCharts from 'react-apexcharts';
// import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import { Badge, Modal, Dropdown, Tab, Tabs, Button, Form, Stack } from 'react-bootstrap';

import { faPlus, faXmark, faCircle, faPaperclip, faPencil, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';

import Header from "../../../../Components/Header/Header";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../../Components/TopMenu/TopMenu';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import edit from "../../../../assets/images/edit.png";
import Export from "../../../../assets/images/export.svg";
import EmailGreen from "../../../../assets/images/recover_email.png";
import EmailRed from "../../../../assets/images/pending_email.png";
import { GETAGENT, GETCONDITIONCODE, GETDESTINATION, GETOWNERCODE, GETULDDETAILS, MVTHDETAILS, ULDSETRECOVERY, UPDATERECOVERY } from '../../../../Utils/conts';
import { withRFSToken } from '../../../../Services/axios.js';
import { toast } from 'react-toastify';
import RecoveryDetails from './RecoveryDetails.js';
import DownloadGrid from '../components/DownloadGrid.js';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

function Missing() {
    const isMounted = useRef(false);
    const [activeTab, setActiveTab] = useState('Active');
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const [totalRows, setTotalRows] = useState([]);
    const [totalRowsC, setTotalRowsC] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [emailData, setEmailData] = useState();
    const [foundData, setFoundData] = useState({ movement_history: [] });
    const [changeData, setChangeData] = useState({ movement_history: [] });
    const [showModal, setShowModal] = useState(false);
    const [missingModal, setMissingModal] = useState(false);
    const handleModalClose = () => { setShowModal(false); };
    const [isSaving, setIsSaving] = useState(false);

    const [gridData, setGridData] = useState({
        Active: [],
        Closed: []

    });

    const [formData, setFormData] = useState({});
    const [updatedData, setUpdatedData] = useState({});
    const [getOwnerCode, setGetOwnerCode] = useState([]);
    const [getCondCode, setGetCondCode] = useState([]);
    const [getDestination, setGetDestination] = useState([]);

    const [originHandler, setOriginHandler] = useState([]);
    const [selectedOriginId, setSelectedOriginId] = useState(null);
    const [selectedOriginHandler, setSelectedOriginHandler] = useState(null);
    const [destinationHandler, setDestinationHandler] = useState([]);
    const [selectedDestinationId, setSelectedDestinationId] = useState(null);
    const [selectedDestinationHandler, setSelectedDestinationHandler] = useState(null);

    const [transferredBy, setTransferredBy] = useState([]);
    const [selectedTransferredBy, setSelectedTransferredBy] = useState(null);
    const [receivedBy, setReceivedBy] = useState([]);
    const [selectedReceivedBy, setSelectedReceivedBy] = useState(null);

    const gridRef = useRef(null);

    const fetchOwnerCode = async () => {
        try {

            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA
                    })) : [];
                    setGetOwnerCode(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchCondCode = async () => {
        try {

            const res = await withRFSToken.post(GETCONDITIONCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setGetCondCode(innerData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDestination = async () => {
        try {

            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const getCondCodes = [
        { label: 'Serviceable', value: 'SER' },
        { label: 'Damaged', value: 'DAM' },
        { label: 'Discarded', value: 'DIS' },
    ];
    const getStatus = [
        { label: 'In Operation', value: 1 },
        { label: 'On Air', value: 4 },
        { label: 'On Loan', value: 5 },
        { label: 'Repair', value: 2 },
        { label: 'In Reserve', value: 3 },
        // { label: 'Missing', value: 17 },
    ];

    useEffect(() => {
        if (isMounted.current) return;

        setIsLoading(false);
        setGridData({ Active: {} });
        isMounted.current = true;
    }, []);

    const gridRefs = {
        Active: useRef(null),
        Closed: useRef(null),
    };
    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        setGridSelect([]);
        setIsLoading(true);
        if (tab == 'Active') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Active: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Closed: {} });
            }, 1);
        }
    };

    // ++++++++++++++ Status Overview.

    const [statusSeries, setStatusSeries] = useState([
        {
            name: 'ULD Status',
            data: []
        },
    ]);

    const maxValue = Math.max(...statusSeries[0].data) + 10;

    const [statusOptions, setStatusOptions] = useState({
        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                show: false // This will hide the toolbar
            }
        },
        plotOptions: {
            bar: {
                horizontal: true,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                distributed: true,
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: 0,
            offsetX: 25,
            formatter: (val) => {
                return val;
            },
            style: {
                fontSize: '12px',
                colors: ["#304758"]
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: [],
        },
        yaxis: {
            title: {
                text: ' '
            },
            // tickAmount: 5,
            // max: maxValue,
            // labels: {
            //     formatter: function (val) {
            //         return Math.floor(val); // Ensure the y-axis ticks are integers
            //     }
            // }
        },
        fill: {
            opacity: 1,
            colors: [
                "rgba(193, 193, 193, 1)",
                "rgba(101, 180, 236, 1)",
                "rgba(251, 170, 93, 1)",
                'rgba(254, 221, 91, 1)',
                'rgba(99, 233, 134, 1)',
                'rgba(246, 75, 76, 1)',
            ]
        },
        legend: {
            show: false
        },
        colors: ['#d6d6d6', '#ff5522', '#ffb63f', '#20a749'], // Different colors for each bar group
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " units";
                }
            }
        }
    });

    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRefs[activeTab]?.current) {
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall()
            let tabType = '';
            if (activeTab == 'Active') { tabType = '1' } else { tabType = '0' }
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'email_status', type: 'string' },
                    { name: 'uld_number', type: 'string' },
                    { name: 'case_status', type: 'string' },
                    { name: 'recovery_status', type: 'string' },
                    { name: 'last_seen', type: 'string' },
                    { name: 'last_seen_loc', type: 'string' },
                    { name: 'last_movement', type: 'string' },
                    { name: 'missing_id', type: 'string' },
                    { name: 'station', type: 'string' },
                ],
                // localData: gridData,
                id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}recovery/uld-list?type=${tabType}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 20,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


                    // setTimeout(() => {
                    //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

                    //     console.log("rows", rows);
                    //     (checkUlds).forEach(uldNumber => {
                    //         console.log(checkUlds);
                    //         rows.forEach((element, index) => {
                    //             if (element.uld_number == uldNumber) {
                    //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                    //             }
                    //         });
                    //     });
                    // }, 4000);
                },
                beforeprocessing: function (data) {
                    // source.totalrecords = data.TotalRows;
                    // setTotalRows({ totalUlds: data.activeCount });
                    // setTotalRowsR({ totalUlds: data.archiveCount });
                    const categories = data.chart_data.map(item => item.case_status.split(" "));
                    const caseCounts = data.chart_data.map(item => item.case_count);

                    setStatusOptions(prevOptions => ({
                        ...prevOptions,
                        xaxis: {
                            ...prevOptions.xaxis,
                            categories: categories // Transformed categories
                        }
                    }));

                    // Update chart series with new case count data
                    setStatusSeries([{
                        name: 'ULD Status',
                        data: caseCounts
                    }]);
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                // {
                //     text: 'Actions',
                //     cellsrenderer: function () {
                //         return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
                //     },
                //     width: '5%', filterable: false,
                // },
                {
                    text: 'Email', filtertype: 'textbox', datafield: 'email_status', width: '4%', cellclassname: '', filterable: false,
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        if (rowdata.email_status === 0) {
                            return '<div class="grid_actions row_email_red"><img src="' + EmailRed + '" class="" /></div>';
                        } else {
                            return '<div class="grid_actions row_email_green"><img src="' + EmailGreen + '" class="row_email" /></div>';
                        }
                    },
                },
                { text: 'ULD Number', filtertype: 'textbox', datafield: 'uld_number', width: '12%', cellclassname: '', },
                {

                    text: 'Case Status', datafield: 'case_status', width: '14%', cellclassname: (row, column, value) => {
                        switch (value) {
                            case 'Pending Verification':
                                return 'pending_vrifi';
                            case 'Notified':
                                return 'notified';
                            case 'Recovered':
                                return 'recovered';
                            case 'Email Missing':
                                return 'email_missing';
                            case 'Response Received':
                                return 'response';
                            case 'Declared Lost':
                                return 'declared';
                            default:
                                return 'register_default'; // Fallback class for unknown statuses
                        }
                    },
                    filterable: true, filtertype: 'checkedlist',
                    filteritems: [
                        { label: 'Pending Verification', value: 'Pending Verification' },
                        { label: 'Notified', value: 'Notified' },
                        { label: 'Recovered', value: 'Recovered' },
                        { label: 'Email Missing', value: 'Email Missing' },
                        { label: 'Response Received', value: 'Response Received' },
                        { label: 'Declared Lost', value: 'Declared Lost' },
                    ],
                },
                {
                    text: 'Recovery Status', datafield: 'recovery_status', width: '12%', cellclassname: '', filterable: true, filtertype: 'checkedlist',
                    filteritems: [
                        { label: 'ULD Found', value: 'ULD Found' },
                        { label: 'ULD Lost', value: 'ULD Lost' },
                        { label: 'Departed on', value: 'Departed on' },
                        { label: 'Transferred to other Handler', value: 'Transferred to other Handler' },
                        { label: 'Returned to Handler', value: 'Returned to Handler' },
                        { label: 'Delivered to External Party', value: 'Delivered to External Party' },
                        { label: 'Other', value: 'Other' },
                    ],
                },
                {
                    text: 'Last Movement', datafield: 'last_movement', width: '15%', cellclassname: '',
                    filterable: true, filtertype: 'checkedlist',
                    filteritems: [
                        { label: 'Repair In', value: 'Repair In' },
                        { label: 'Repair Out', value: 'Repair Out' },
                        { label: 'SCM', value: 'SCM' },
                        { label: 'Lease Out', value: 'Lease Out' },
                        { label: 'UCM Out', value: 'UCM Out' },
                        { label: 'UCM In', value: 'UCM In' },
                        { label: 'LUC In', value: 'LUC In' },
                        { label: 'LUC Out', value: 'LUC Out' },
                        { label: 'Transfer', value: 'Transfer' },
                        { label: 'Request', value: 'Request' },
                    ],
                },
                { text: 'Last Seen Date', datafield: 'last_seen', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', width: '15%', cellclassname: '', },
                { text: 'Last Seen Location', filtertype: 'textbox', datafield: 'last_seen_loc', width: '15%', cellclassname: '', },
            ];
            const gridOptions = {
                // width: '100%',
                // source: dataAdapter,
                // columns: columns,
                // autoheight: false,
                // height: 1040,
                // sortable: true,
                // altrows: false,
                // columnsresize: false,
                // enabletooltips: false,
                // editable: false,
                // selectionmode: 'checkbox',
                // pageable: true,
                // pageSize: 20,
                // pagesizeoptions: ['20', '50', '100', '200', '500'],
                // pagerButtonsCount: 5,
                // pagerMode: 'advanced',
                // filterable: true,
                // filterrowheight: 45,
                // showfilterrow: true,
                // rowsheight: 42,
                // columnsheight: 45,
                // showstatusbar: true,
                // virtualmode: true,
                // rendergridrows: function (params) {
                //     return params.data;
                // },
                width: "100%",
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 800,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                selectionmode: 'checkbox',
                editable: false,
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ["50", "100", "200", "500"],
                pagerButtonsCount: 5,
                pagerMode: "advanced",
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                rowdetails: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
            };
            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                const dataToSend = {
                    uld_number: rowData.uld_number,
                    type_code: rowData.type_code,
                    serial_number: rowData.serial_number,
                    owner_code: rowData.owner_code,
                    condition_code: rowData.condition_code,
                    asset_type: rowData.asset_type == 'Y' ? false : true
                };
                // setEditData(dataToSend);
                // setShowEdit(true);
            });
            window.$(gridRefs[activeTab].current).on('click', '.row_email_red', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                setEmailData(rowData)
                setShowModal(true)
                fetchHandler(rowData.station)
            });
            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.uld_number;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.uld_number === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.uld_number === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.uld_number;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.uld_number !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 1) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                    // setSelectedRowData(args)
                    loadDetails(args.uld_number, args.missing_id);
                }
            });
        }
    }, [gridData]);

    const loadDetails = async (uldNumber, missingId, forFound) => {
        try {
            const res = await withRFSToken.post(GETULDDETAILS, { uld_number: uldNumber, missing_id: missingId })
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        const innerData = res.data.response_data;
                        if (forFound) {
                            setFoundData(innerData);
                            setChangeData(innerData);
                            setMissingModal(true);
                            setFormData(innerData.movement_history[0]);
                            fetchOwnerCode();
                            fetchCondCode();
                            fetchDestination();
                        } else {
                            setSelectedRowData(innerData);
                        }
                    } else {
                        toast.error(res.data.response_msg);
                    }

                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (formData?.origin) {
            const selectedOrigin = getDestination.find(option => option.value === formData?.origin);
            const selectedOriginHandler = selectedOrigin?.address?.find(option => option.id === formData?.origin_handler_id);
            if (selectedOrigin) {
                setOriginHandler(selectedOrigin.address);
                setSelectedOriginId(selectedOrigin.station_id);
                setSelectedOriginHandler({ label: selectedOriginHandler?.company_name, value: selectedOriginHandler?.id });
            } else {
                // Reset or handle if the origin value doesn't match any destination
                setOriginHandler([]);
                setSelectedOriginId(null);
                setSelectedOriginHandler(null);
            }
        } else {
            setOriginHandler([]);
            setSelectedOriginId(null);
            setSelectedOriginHandler(null);
        }
        if (formData?.destination) {
            const selectedDestination = getDestination.find(option => option.value === formData.destination);
            const selectedDestinationHandler = selectedDestination?.address?.find(option => option.id === formData?.destination_handler_id);
            if (selectedDestination) {
                setDestinationHandler(selectedDestination.address);
                setSelectedDestinationId(selectedDestination.station_id);
                setSelectedDestinationHandler({ label: selectedDestinationHandler?.company_name, value: selectedDestinationHandler?.id } || null);
            } else {
                // Reset or handle if the origin value doesn't match any destination
                setDestinationHandler([]);
                setSelectedDestinationId(null);
                setSelectedDestinationHandler(null);
            }
        } else {
            setDestinationHandler([]);
            setSelectedDestinationId(null);
            setSelectedDestinationHandler(null);
        }
        if (formData?.transfer_point) {
            const selectedTransferPoint = getDestination.find(option => option.value === formData.transfer_point);
            const selectedTransferBy = selectedTransferPoint?.address?.find(option => option.id === formData?.transferred_by_id);
            if (selectedTransferPoint) {
                setTransferredBy(selectedTransferPoint.address);
                setSelectedTransferredBy({ label: selectedTransferBy?.company_name, value: selectedTransferBy?.id } || null);
            } else {
                // Reset or handle if the origin value doesn't match any destination
                setTransferredBy([]);
                setSelectedTransferredBy(null);
            }
        } else {
            setTransferredBy([]);
            setSelectedTransferredBy(null);
        }
        if (formData?.luc_final_dest) {
            const selectedFinalDest = getDestination.find(option => option.value === formData.luc_final_dest);
            const selectedReceivedBy = selectedFinalDest?.address?.find(option => option.id === formData?.received_by_id);
            if (selectedFinalDest) {
                setReceivedBy(selectedFinalDest.address);
                setSelectedReceivedBy({ label: selectedReceivedBy?.company_name, value: selectedReceivedBy?.id } || null);
            } else {
                // Reset or handle if the origin value doesn't match any destination
                setReceivedBy([]);
                setSelectedReceivedBy(null);
            }
        } else {
            setReceivedBy([]);
            setSelectedReceivedBy(null);
        }
    }, [formData, getDestination])

    const handleDropdownItemClick = (pos, action) => {
        const keysToRemove = ['Repair In', 'Repair Out', 'SCM', 'Lease Out', 'UCM Out', 'UCM In', 'LUC In', 'LUC Out', 'Transfer', 'Request'];
        keysToRemove.forEach(key => localStorage.removeItem(key));



        // const missingUld = async (uld) => {
        //     setMissingModal(true);
        //     setMissingInfo(uld);
        // }


        // Logic for handling 'top' position
        const handleTopAction = () => {

            if (gridSelect.length === 0) {
                toast.error('Please select at least one stock to Operate');

            } else {
                if (action === 'ULD Found') {
                    if (gridSelect.length > 1) {
                        toast.error('You Can process only one ULD at a time')
                    } else {
                        if (gridSelect[0].status == 'Missing') {
                            toast.error('ULD is already Missing')
                        } else {
                            // missingUld(gridSelect[0].uld_number);
                            loadDetails(gridSelect[0].uld_number, gridSelect[0].missing_id, 'found');
                        }
                    }
                } else {
                }
            }
        };

        // Main conditional logic based on the position (pos)
        if (pos === 'details') {
            // handleDetailsAction();
        } else if (pos === 'top') {
            handleTopAction();
        }
    };

    const missingModalClose = () => {
        setMissingModal(false);
        setIsEdit(false);
        setFormData({});
    }
    const reportFound = async () => {
        setIsSaving(true);
        // let sendData = {};
        // if (isedit) {
        const sendData = {
            ...formData,
            missing_id: foundData.missing_details.missing_id,
            status: foundData.last_uld_status_id,
            condition_code: foundData.condition_code,
            flight_number: `${formData.flight_code}-${formData.flight_num}`,
        };
        // } else {
        //     sendData = {
        //         ...formData,
        //         missing_id: foundData.missing_details.missing_id,
        //         status: foundData.last_uld_status_id,
        //         condition_code: foundData.condition_code,
        //         flight_number: `${formData.flight_code}-${formData.flight_num}`,
        //     };
        // }
        try {
            const res = await withRFSToken.post(UPDATERECOVERY, sendData)
            // .then(function (res) {
            if (res.data.response_code == 200) {
                toast.success('ULD Reported as Found Successfully');
                window.$(gridRefs[activeTab]).jqxGrid('updatebounddata');
                // setGridData({ Active: {} });
                setMissingModal(false);
                setIsLoading(true);
                setIsSaving(false);
                if (activeTab == 'Active') {
                    setTimeout(() => {
                        setIsLoading(false);
                        setGridData({ Active: {} });
                    }, 1);
                } else {
                    setTimeout(() => {
                        setIsLoading(false);
                        setGridData({ Closed: {} });
                    }, 1);
                }

                setGridSelect([]);
            } else { toast.error(res.data.response_msg); setIsSaving(false); }
            // });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleCloseClick = () => {
        setSelectedRowData(null);
    };
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    const [recEmailData, setRecEmailData] = useState({ agent_or_handler: 'H', rec_email: '' });
    const [agentHandlers, setAgentHandlers] = useState([]);
    const handleEmailChange = (e) => {
        const { name, value } = e.target;
        if (name === 'agent_or_handler') {

            if (value === 'A') {
                fetchAgent(emailData.station)
            } else if (value === 'H') {
                fetchHandler(emailData.station)
            }
            setRecEmailData(prevState => ({
                ...prevState,
                agent_or_handler_id: '',
                [name]: value
            }));
        }
        setRecEmailData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const fetchAgent = async (val) => {
        try {
            const res = await withRFSToken.post(GETAGENT, { station: val })
                // const res = await withRFSToken.post('uld-settings/station-address', { station_id: emailData, user_type: val })
                .then(function (res) {
                    const innerData = res.data.response_data[0].address;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.id,
                        label: item.company_name,
                    })) : [];
                    setAgentHandlers(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchHandler = async (val) => {
        try {
            const res = await withRFSToken.post(GETDESTINATION, { station: val })
                // const res = await withRFSToken.post('uld-settings/station-address', { station_id: emailData, user_type: val })
                .then(function (res) {
                    const innerData = res.data.response_data[0].address;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.id,
                        label: item.company_name,
                    })) : [];
                    setAgentHandlers(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const setRecoveryMail = async () => {
        // console.log('444', emailData);
        const payload = {
            missing_id: emailData.missing_id,
            agent_or_handler: recEmailData?.agent_or_handler,
            agent_or_handler_id: recEmailData?.agent_or_handler_id,
            email: recEmailData.rec_email
        }

        try {
            const res = await withRFSToken.post(ULDSETRECOVERY, payload)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (res.data.response_code === 200) {
                        setTimeout(() => {
                            setIsLoading(false);
                            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                        }, 1);
                        handleModalClose();
                    } else {
                        toast.error(res.data.response_msg);
                    }


                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const RecoveryDetails = (un) => {
        localStorage.setItem('UN', un);
        window.location.href = '/RecoveryDetails';
    }

    const movementHistoryClick = () => {
        try {
            // Check if selectedRowData is defined
            if (!selectedRowData) {
                throw new Error('Selected row data is not available.');
            }

            localStorage.removeItem('MHistory');
            const storageData = {
                ULD: selectedRowData,  // ULD Details section
                Form: {}  // Empty form section
            };
            localStorage.setItem('MHistory', JSON.stringify(storageData));
            localStorage.setItem('tab', 'assets');
            window.location.href = '/ULDControl/MovementHistory'
        } catch (error) {
            // Log the error for debugging purposes
            console.error('Error during navigation:', error.message);
            alert('An error occurred: ' + error.message); // Optional user alert
        }
    };
    const handleDetailsClick = async (history) => {

        if (!selectedRowData) {
            throw new Error('Selected row data is not available.');
        }
        try {
            const res = await withRFSToken.post(MVTHDETAILS, { uld_id: selectedRowData.uld_id, uld_status_id: history.uld_status_id })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    localStorage.removeItem('MHistory');
                    localStorage.removeItem('MHDetails');
                    const storageData = {
                        ULD: selectedRowData,  // ULD Details section
                        Form: {}  // Empty form section
                    };
                    localStorage.setItem('MHistory', JSON.stringify(storageData));
                    const storageDataDetails = {
                        ULD: innerData.others_ulds,  // ULD Details section
                        Form: innerData.uld_movement_detail,
                        tab: 'All'  // Empty form section
                    };
                    localStorage.setItem('MHDetails', JSON.stringify(storageDataDetails));
                    // localStorage.setItem('tab', 'operations');
                    let detailsPageUrl;
                    const detailsType = history.operation_type || history.ucm_inout || history.luc_inout || history.repair_inout || history.lease_inout || history.station;
                    if (detailsType) {

                        detailsPageUrl = '/ULDControl/MovementHistorydetails';
                        window.location.href = detailsPageUrl;
                    } else {
                        console.log('No valid details type found');
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const [isedit, setIsEdit] = useState(false);
    const handleEditMode = () => {
        setIsEdit(true);
        setFormData(changeData.movement_history[0]);
    }
    const handleEditModeBack = () => {
        setIsEdit(false);
        setFoundData(changeData);
        setFormData(changeData.movement_history[0]);
    }
    const handleFoundChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    }
    const [downloadOpen, setDownloadOpen] = useState(false);
    const showDownloadModal = () => {
        setDownloadOpen(true);
    };
    const closeDownloadModal = () => {
        setDownloadOpen(false);

    };
    return (
        <>
            {console.log('recEmailData', recEmailData)}
            {downloadOpen && <DownloadGrid download_sec={'Missing'} onClose={closeDownloadModal} />}
            <div className='lcontent'>
                <div className="mb-3 nestedtabs rounded minh">
                    <div className='d-flex'>
                        <Dropdown>
                            <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                                <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'ULD Found')}>ULD Found</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <span className="selected">
                            Selected ULD <Badge>{gridSelect.length}</Badge>
                        </span>
                    </div>
                </div>

                <div className='ulddown'>
                    <button onClick={showDownloadModal}><img src={Export} /> Download</button>
                </div>

                <div className="maindiv">
                    <div className='trashdonload'>
                        <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                            <Tab eventKey="Active" title={<span>Active <Badge className='rabadge'>{totalRows.totalUlds}</Badge></span>} className='moveto'>
                                {/* <Loader isLoading={isLoading} /> */}
                                {!isLoading && <>
                                    {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>} */}
                                    <div ref={gridRefs.Active} className='bookinggrid' ></div>
                                </>
                                }
                                {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
                            </Tab>
                            <Tab eventKey="Closed" title={<span>Closed <Badge className='rabadge'>{totalRowsC.totalUlds}</Badge></span>} className='moveto'>
                                {/* <Loader isLoading={isLoading} /> */}
                                {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>} */}
                                {!isLoading && <div ref={gridRefs.Closed} className='bookinggrid' ></div>}
                                {/* <div ref={gridRefs.Closed} className='bookinggrid' ></div> */}
                            </Tab>
                        </Tabs>
                    </div>


                    <div className='rfsRight mt-45'>
                        {!selectedRowData && (
                            <>
                                <div className='calender_rfs  h-100'>
                                    <div className="new_chart">
                                        <h3>ULD Recovery Status Overview</h3>
                                        <p>Overview of Current ULD Recovery Statuses</p>
                                    </div>
                                    <ApexCharts
                                        options={statusOptions}
                                        series={statusSeries}
                                        type="bar"
                                        height={'95%'}
                                    />
                                </div>
                            </>
                        )}
                        {selectedRowData && (
                            <div className='SecondDiv rfs_width'>
                                {/* {console.log('55', selectedRowData)} */}
                                <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                                <div className='girddtals_header'>
                                    <h3>
                                        {selectedRowData.uld_number} &nbsp; <span>{/* selectedRowData.status */}</span>
                                    </h3>
                                    <div className='d-flex actbtn'>

                                        <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                        {/* <Dropdown>
                                                            <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                                                <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu>
                                                                <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'In Operation')}>In Operation</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'Repair In')}>Repair In</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'Repair Out')}>Repair Out</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'In Reserve')}>In Reserve</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'Lease Out')}>Lease Out</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'SCM')}>SCM</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown> */}

                                    </div>

                                </div>

                                <div className={`d-flex justify-content-between align-items-center recovry_details 
                                                ${selectedRowData?.missing_details.case_status === 'Notified' ? 'notiybg'
                                        :
                                        (selectedRowData?.missing_details.case_status === 'Email Missing' ? 'email_bg'
                                            :
                                            (selectedRowData?.missing_details.case_status === 'Recovered' ? 'recovered_bg'
                                                :
                                                (selectedRowData?.missing_details.case_status === 'Response Received' ? 'recived_bg'
                                                    :
                                                    (selectedRowData?.missing_details.case_status === 'Declared Lost' ? 'lost_bg' : ''))))}`}>
                                    <div>
                                        <span>
                                            {selectedRowData?.missing_details.user_type === 'H' ? 'Handler'
                                                :
                                                (selectedRowData?.missing_details.user_type === 'F' ? 'Forwarder' : '')}
                                        </span>
                                        <p>{selectedRowData?.missing_details.last_seen_loc}</p>
                                    </div>
                                    <h4>{selectedRowData?.missing_details.case_status}</h4>
                                    <Link to='#' onClick={() => RecoveryDetails(selectedRowData?.missing_details?.missing_id)}>Details</Link>
                                </div>

                                {/* <div className='d-flex justify-content-between rabord'>
                                                    <div className='firstbrd'>
                                                        <p>Origin</p>
                                                        <span>{selectedRowData.origin}</span>
                                                    </div>
                                                    <div className='middlebrd'>
                                                        <p>{selectedRowData.flight_date}</p>
                                                        <p><img src={Cargoplane} /></p>
                                                        <p>{selectedRowData.flight_number}</p>
                                                    </div>
                                                    <div className='lastbrd'>
                                                        <p>Destination</p>
                                                        <span>{selectedRowData.destination}</span>
                                                    </div>
                                                </div> */}
                                <div className='movment_history'>
                                    <h3>Movement History</h3> <Link to='#' onClick={movementHistoryClick}>View All</Link>
                                </div>
                                <div className='movment_list'>
                                    <ul>
                                        {selectedRowData && selectedRowData.movement_history.slice(0, 5).map((history, index) => (
                                            <li key={index}>
                                                <span className='movem'>{history.operation_type}</span> <span className='mvdate'>{history.operation_date}</span>
                                                <Link to="#" onClick={() => handleDetailsClick(history)}>Details</Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                <ImageUpload
                                    ref={imageUploadRef}
                                    attachable_type={"uld"}
                                    attachable_id={selectedRowData.uld_number}
                                    attachments={selectedRowData.attachments}
                                    onDeleteSuccess={() => loadDetails(selectedRowData.uld_number)}
                                />
                                <ActivityComments
                                    commentable_type={"uld"}
                                    commentable_id={selectedRowData.uld_number}
                                    allactivities={selectedRowData.activities}
                                    onReloadDetails={loadDetails}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                        <h3>{emailData?.last_seen_loc}</h3>
                        <div className='d-flex mt-4'>
                            <div>
                                <Form.Check
                                    inline
                                    label="Handler"
                                    name="agent_or_handler"
                                    type='radio'
                                    id='ftl'
                                    value="H"
                                    checked={recEmailData?.agent_or_handler === 'H'}
                                    onChange={handleEmailChange}
                                />
                            </div>
                            <div>
                                <Form.Check
                                    inline
                                    label="Agent"
                                    name="agent_or_handler"
                                    type='radio'
                                    id='ltl'
                                    value="A"
                                    checked={recEmailData?.agent_or_handler === 'A'}
                                    onChange={handleEmailChange}
                                />
                            </div>
                        </div>
                        <div className='ltl_drop mb-2'>
                            {/* {formData?.service_type === 'L' && */}
                            <Form.Label>Select {recEmailData?.agent_or_handler === 'A' ? 'Agent' : 'Handler'}</Form.Label>
                            <Select
                                options={agentHandlers}
                                onChange={(selected) => {
                                    const updatedData = { ...recEmailData, agent_or_handler_id: selected.value };
                                    setRecEmailData(updatedData);
                                }}
                                placeholder={recEmailData?.agent_or_handler === 'A' ? 'Select Agent' : 'Select Handler'}
                                className='autoslct rfslct'
                                name="agent_or_handler_id"
                                // isDisabled={boardPointAddress.length > 0 ? false : true}
                                value={recEmailData.agent_or_handler_id ? agentHandlers.find(option => option.value === String(recEmailData.agent_or_handler_id)) : ''}
                            />
                            {/* } */}
                        </div>
                        <Form.Label>Recovery Email Address</Form.Label>
                        <Form.Control name='rec_email' placeholder='Recovery Email Address' onChange={handleEmailChange} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <div className=' w-50 mx-auto are_bottom'>
                        <Button variant="primary" onClick={setRecoveryMail}>
                            Submit
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={missingModal} onHide={!isSaving ? missingModalClose : null} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>ULD Found - {foundData.uld_number}</h3>
                    <p>Please review the information below and select the <br /> Report ULD Found button to report the ULD as found. </p>

                    <div className='missing_info mb-0'>

                        <h4 className='position-relative'>ULD Status
                            <Link className='raedit' to='#' onClick={isedit ? handleEditModeBack : handleEditMode}>{isedit ? '' : <FontAwesomeIcon icon={faPencil} />} {isedit ? 'Back' : 'Edit'}</Link></h4>
                        <p>The status of the ULD will be changed to the following</p>

                        <ul className='rauld_found'>
                            <li><span>Status</span>
                                <span className='d-flex'>
                                    <label>:</label>
                                    {isedit ?
                                        <Select
                                            options={getStatus}
                                            onChange={(selected) => {
                                                const updatedData = { ...foundData, last_uld_status_id: selected.value, last_uld_status: selected.label };
                                                setFoundData(updatedData);
                                                setUpdatedData({ ...updatedData, last_uld_status_id: selected.value });
                                            }}
                                            placeholder="Status"
                                            className='autoslct'
                                            name="status"
                                            value={getStatus.find(option => option.value == foundData?.last_uld_status_id) || ''}
                                        />
                                        :
                                        <>{changeData.last_uld_status}</>
                                    }
                                </span></li>
                            <li><span>Condition</span>
                                <span className='d-flex'>
                                    <label>:</label>
                                    {isedit ?
                                        <Select
                                            options={getCondCodes}
                                            onChange={(selected) => {
                                                const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                const updatedData = { ...foundData, condition_code: selected.value };
                                                setFoundData(updatedData);
                                                setUpdatedData({ ...updatedData, condition_code: selected.value });
                                            }}
                                            placeholder="Condition Code"
                                            className='autoslct'
                                            name="condition_code"
                                            value={getCondCodes.find(option => option.value === foundData?.condition_code) || ''}
                                        />
                                        :
                                        <>{changeData.condition}</>
                                    }
                                </span></li>
                        </ul>
                        <hr />
                        <ul className='rauld_found'>
                            {['In Operation', 'On Air', 'In Reserve'].includes(foundData?.last_uld_status) ?
                                <>
                                    {/* {console.log('foundData', foundData?.movement_history[0]?.flight_number)} */}
                                    <li>
                                        <span>Flight Number </span>
                                        <span className='d-flex'>
                                            <label>:</label>
                                            {isedit ?
                                                <>
                                                    <Select
                                                        options={getOwnerCode}
                                                        onChange={(selected) => {
                                                            const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                            const updatedData = { ...formData, flight_code: selected.value };
                                                            setFormData(updatedData);
                                                            // setUpdatedData({ ...updatedData, origin: selected.value });
                                                        }}
                                                        placeholder="Code"
                                                        className='autoslct'
                                                        name="flight_code"
                                                        value={getOwnerCode.find(option => option.value === formData?.flight_code)}
                                                    /> -
                                                    <Form.Control
                                                        type="text"
                                                        placeholder=""
                                                        name='flight_num'
                                                        maxLength={9}
                                                        onChange={handleFoundChange}
                                                        value={formData?.flight_num || ''}
                                                    />
                                                </>
                                                : <>{foundData?.movement_history[0]?.flight_number}</>
                                            }
                                        </span>
                                    </li>
                                    <li>
                                        <span>Flight Date </span>
                                        <span className='d-flex'>
                                            <label>:</label>
                                            {isedit ?
                                                <>
                                                    <Form.Control
                                                        type="date"
                                                        placeholder=""
                                                        name='flight_date'
                                                        maxLength={9}
                                                        onChange={handleFoundChange}
                                                        value={formData?.flight_date || ''}
                                                    />
                                                </>
                                                : <>{foundData?.movement_history[0]?.flight_date}</>
                                            }
                                        </span>
                                    </li>
                                    <li>
                                        <span>Origin </span>
                                        <span className='d-flex'>
                                            <label>:</label>
                                            {isedit ?
                                                <>
                                                    {/* <Form.Control
                                                        type="text"
                                                        placeholder=""
                                                        name='origin'
                                                        maxLength={9}
                                                        // onChange={handleInputChange}
                                                        value={foundData?.movement_history[0]?.origin || ''}
                                                    /> */}
                                                    <Select
                                                        options={getDestination}
                                                        onChange={(selected) => {
                                                            const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                            const updatedData = { ...formData, origin: selected.value, handler_name: '' };
                                                            setFormData(updatedData);
                                                            setOriginHandler(selectedDestination ? selectedDestination.address : []);
                                                            setSelectedOriginId(selectedDestination.station_id);
                                                            setSelectedOriginHandler(null);
                                                            setUpdatedData({ ...updatedData, origin: selected.value });
                                                        }}
                                                        placeholder="Origin"
                                                        className='autoslct'
                                                        name="origin"
                                                        value={getDestination.find(option => option.value === formData?.origin)}
                                                    />
                                                </>
                                                : <>{foundData?.movement_history[0]?.origin}</>
                                            }
                                        </span>
                                    </li>
                                    <li>
                                        <span>Origin Handler Name</span>
                                        <span className='d-flex'>
                                            <label>:</label>
                                            {isedit ?
                                                <>

                                                    <Select
                                                        options={originHandler.map(handler => ({
                                                            value: handler.id,
                                                            label: handler.company_name
                                                        }))}
                                                        onChange={(selected) => {
                                                            const updatedData = { ...formData, origin_handler_id: selected.value, origin_handler: selected.label };
                                                            setFormData(updatedData);
                                                            setSelectedOriginHandler(selected);
                                                            setUpdatedData(updatedData);
                                                        }}
                                                        placeholder="Handler Name"
                                                        className='autoslct'
                                                        name="origin_handler"
                                                        // value={originHandler.find(option => option.value === (selectedOriginHandler ? selectedOriginHandler.value : ''))}
                                                        value={selectedOriginHandler ? { value: selectedOriginHandler.value, label: selectedOriginHandler.label } : null}
                                                        isDisabled={!originHandler.length}
                                                    />
                                                </>
                                                : <>{foundData?.movement_history[0]?.origin_handler}</>
                                            }
                                        </span>
                                    </li>
                                    <li>
                                        <span>Destination</span>
                                        <span className='d-flex'>
                                            <label>:</label>
                                            {isedit ?
                                                <>
                                                    {/* <Form.Control
                                                        type="text"
                                                        placeholder=""
                                                        name='destination'
                                                        maxLength={9}
                                                        // onChange={handleInputChange}
                                                        value={foundData?.movement_history[0]?.destination || ''}
                                                    /> */}
                                                    <Select
                                                        options={getDestination}
                                                        onChange={(selected) => {
                                                            const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                            const updatedData = { ...formData, destination: selected.value, handler_name: '' };
                                                            setFormData(updatedData);
                                                            setDestinationHandler(selectedDestination ? selectedDestination.address : []);
                                                            setSelectedDestinationId(selectedDestination.station_id);
                                                            setSelectedDestinationHandler(null);
                                                            setUpdatedData({ ...updatedData, destination: selected.value });
                                                        }}
                                                        placeholder="Destination"
                                                        className='autoslct'
                                                        name="destination"
                                                        value={getDestination.find(option => option.value === formData?.destination)}
                                                    />
                                                </>
                                                : <>{foundData?.movement_history[0]?.destination}</>
                                            }
                                        </span>
                                    </li>
                                    <li>
                                        <span>Destination Handler Name</span>
                                        <span className='d-flex'>
                                            <label>:</label>
                                            {isedit ?
                                                <>
                                                    {/* <Form.Control
                                                        type="text"
                                                        placeholder=""
                                                        name='destination_handler'
                                                        maxLength={9}
                                                        // onChange={handleInputChange}
                                                        value={foundData?.movement_history[0]?.destination_handler || ''}
                                                    /> */}
                                                    <Select
                                                        options={destinationHandler.map(handler => ({
                                                            value: handler.id,
                                                            label: handler.company_name
                                                        }))}
                                                        onChange={(selected) => {
                                                            const updatedData = { ...formData, destination_handler_id: selected.value, destination_handler: selected.label };
                                                            setFormData(updatedData);
                                                            setSelectedDestinationHandler(selected);
                                                            setUpdatedData(updatedData);
                                                        }}
                                                        placeholder="Handler Name"
                                                        className='autoslct'
                                                        name="destination_handler"
                                                        // value={handlerNames.find(option => option.value === (selectedHandler ? selectedHandler.value : ''))}
                                                        value={selectedDestinationHandler ? { value: selectedDestinationHandler.value, label: selectedDestinationHandler.label } : null}
                                                        isDisabled={!destinationHandler.length}
                                                    />
                                                </>
                                                : <>{foundData?.movement_history[0]?.destination_handler}</>
                                            }
                                        </span>
                                    </li>
                                    <li><span>Registration Number</span>
                                        <span className='d-flex'>
                                            <label>:</label>
                                            {isedit ?
                                                <>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder=""
                                                        name='flight_reg_number'
                                                        maxLength={9}
                                                        onChange={handleFoundChange}
                                                        value={formData?.flight_reg_number || ''}
                                                    />
                                                </>
                                                : <>{foundData?.movement_history[0]?.flight_reg_number}</>
                                            }
                                        </span>
                                    </li>
                                </>
                                : (foundData?.last_uld_status === 'On Loan' ?
                                    <>
                                        <li>
                                            <span>Transfer Date</span>
                                            <span className='d-flex'>
                                                <label>:</label>
                                                {isedit ?
                                                    <>
                                                        <Form.Control
                                                            type="date"
                                                            placeholder=""
                                                            name='operation_date'
                                                            maxLength={9}
                                                            onChange={handleFoundChange}
                                                            value={formData?.operation_date || ''}
                                                        />
                                                    </>
                                                    : <>{foundData?.movement_history[0]?.operation_date}</>
                                                }
                                            </span>
                                        </li>
                                        <li>
                                            <span>Control Receipt Number</span>
                                            <span className='d-flex'>
                                                <label>:</label>
                                                {isedit ?
                                                    <>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder=""
                                                            name='control_receipt_no'
                                                            maxLength={9}
                                                            onChange={handleFoundChange}
                                                            value={formData?.control_receipt_no || ''}
                                                        />
                                                    </>
                                                    : <>{foundData?.movement_history[0]?.control_receipt_no}</>
                                                }
                                            </span>
                                        </li>
                                        <li>
                                            <span>Transfer Point</span>
                                            <span className='d-flex'>
                                                <label>:</label>
                                                {isedit ?
                                                    <>
                                                        <Select
                                                            options={getDestination}
                                                            onChange={(selected) => {
                                                                const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                                const updatedData = { ...formData, transfer_point: selected.value, };
                                                                setFormData(updatedData);
                                                                setTransferredBy(selectedDestination ? selectedDestination.address : []);
                                                                setSelectedTransferredBy(null);
                                                                setUpdatedData({ ...updatedData, luc_final_dest: selected.value });
                                                            }}
                                                            placeholder="TransferPoint"
                                                            className='autoslct'
                                                            name="transfer_point"
                                                            value={getDestination.find(option => option.value === formData?.transfer_point)}
                                                        />
                                                        {/* <Form.Control
                                                            type="text"
                                                            placeholder=""
                                                            name='transfer_point'
                                                            maxLength={9}
                                                            onChange={handleFoundChange}
                                                            value={formData?.transfer_point || ''}
                                                        /> */}
                                                    </>
                                                    : <>{foundData?.movement_history[0]?.transfer_point}</>
                                                }
                                            </span>
                                        </li>
                                        <li>
                                            <span>Transferred By</span>
                                            <span className='d-flex'>
                                                <label>:</label>
                                                {isedit ?
                                                    <>
                                                        <Select
                                                            options={transferredBy.map(handler => ({
                                                                value: handler.id,
                                                                label: handler.company_name
                                                            }))}
                                                            onChange={(selected) => {
                                                                const updatedData = { ...formData, transferred_by_id: selected.value, transferred_by: selected.label };
                                                                setFormData(updatedData);
                                                                setSelectedTransferredBy(selected);
                                                                setUpdatedData(updatedData);
                                                            }}
                                                            placeholder="Transferred By"
                                                            className='autoslct'
                                                            name="transferred_by"
                                                            // value={transferredBy.find(option => option.value === (selectedOriginHandler ? selectedOriginHandler.value : ''))}
                                                            value={selectedTransferredBy ? { value: selectedTransferredBy.value, label: selectedTransferredBy.label } : null}
                                                            isDisabled={!transferredBy.length}
                                                        />
                                                        {/* <Form.Control
                                                            type="text"
                                                            placeholder=""
                                                            name='transferred_by'
                                                            maxLength={9}
                                                            onChange={handleFoundChange}
                                                            value={formData?.transferred_by || ''}
                                                        /> */}
                                                    </>
                                                    : <>{foundData?.movement_history[0]?.transferred_by}</>
                                                }
                                            </span>
                                        </li>
                                        <li>
                                            <span>Final Destination</span>
                                            <span className='d-flex'>
                                                <label>:</label>
                                                {isedit ?
                                                    <>
                                                        <Select
                                                            options={getDestination}
                                                            onChange={(selected) => {
                                                                const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                                const updatedData = { ...formData, luc_final_dest: selected.value, };
                                                                setFormData(updatedData);
                                                                setReceivedBy(selectedDestination ? selectedDestination.address : []);
                                                                setSelectedReceivedBy(null);
                                                                setUpdatedData({ ...updatedData, luc_final_dest: selected.value });
                                                            }}
                                                            placeholder="Final Destination"
                                                            className='autoslct'
                                                            name="luc_final_dest"
                                                            value={getDestination.find(option => option.value === formData?.luc_final_dest) || ''}
                                                        />
                                                        {/* <Form.Control
                                                            type="text"
                                                            placeholder=""
                                                            name='luc_final_dest'
                                                            maxLength={9}
                                                            onChange={handleFoundChange}
                                                            value={formData?.luc_final_dest || ''}
                                                        /> */}
                                                    </>
                                                    : <>{foundData?.movement_history[0]?.luc_final_dest}</>
                                                }
                                            </span>
                                        </li>
                                        <li>
                                            <span>Received By</span>
                                            <span className='d-flex'>
                                                <label>:</label>
                                                {isedit ?
                                                    <>
                                                        <Select
                                                            options={receivedBy.map(handler => ({
                                                                value: handler.id,
                                                                label: handler.company_name
                                                            }))}
                                                            onChange={(selected) => {
                                                                const updatedData = { ...formData, received_by_id: selected.value, received_by: selected.label };
                                                                setFormData(updatedData);
                                                                setSelectedReceivedBy(selected);
                                                                setUpdatedData(updatedData);
                                                            }}
                                                            placeholder="Received By"
                                                            className='autoslct'
                                                            name="received_by"
                                                            // value={receivedBy.find(option => option.value === (selectedOriginHandler ? selectedOriginHandler.value : ''))}
                                                            value={selectedReceivedBy ? { value: selectedReceivedBy.value, label: selectedReceivedBy.label } : null}
                                                            isDisabled={!receivedBy.length}
                                                        />
                                                        {/* <Form.Control
                                                            type="text"
                                                            placeholder=""
                                                            name='received_by'
                                                            maxLength={9}
                                                            onChange={handleFoundChange}
                                                            value={formData?.received_by || ''}
                                                        /> */}
                                                    </>
                                                    : <>{foundData?.movement_history[0]?.received_by}</>
                                                }
                                            </span>
                                        </li>
                                    </>
                                    : (foundData?.last_uld_status === 'Repair' ?
                                        <>
                                            <li>
                                                <span>Repair Name</span>
                                                <span className='d-flex'>
                                                    <label>:</label>
                                                    {isedit ?
                                                        <>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder=""
                                                                name='operation_date'
                                                                maxLength={9}
                                                                onChange={handleFoundChange}
                                                                value={formData?.operation_date || ''}
                                                            />
                                                        </>
                                                        : <>{foundData?.movement_history[0]?.operation_date}</>
                                                    }
                                                </span>
                                            </li>
                                            <li>
                                                <span>Repair Station</span>
                                                <span className='d-flex'>
                                                    <label>:</label>
                                                    {isedit ?
                                                        <>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder=""
                                                                name='repair_station'
                                                                maxLength={9}
                                                                onChange={handleFoundChange}
                                                                value={formData?.repair_station || ''}
                                                            />
                                                        </>
                                                        : <>{foundData?.movement_history[0]?.repair_station}</>
                                                    }
                                                </span>
                                            </li>
                                            <li>
                                                <span>Repair In</span>
                                                <span className='d-flex'>
                                                    <label>:</label>
                                                    {isedit ?
                                                        <>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder=""
                                                                name='repair_in'
                                                                maxLength={9}
                                                                onChange={handleFoundChange}
                                                                value={formData?.repair_in || ''}
                                                            />
                                                        </>
                                                        : <>{foundData?.movement_history[0]?.repair_in}</>
                                                    }
                                                </span>
                                            </li>
                                        </>

                                        : ''
                                    )
                                )
                            }
                        </ul>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={reportFound} disabled={isSaving} className='position-relative'>
                        {isSaving ? <>Report ULD Found<div className='mvt loader-container' style={{ height: 41 + 'px' }}><span className='mvt loader' style={{ top: 3 + 'px', left: 45 + '%' }}></span></div></> : 'Report ULD Found'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Missing